import React, { useState } from 'react';
import {

Box,
Button,
FormControlLabel,
Radio,
RadioGroup,
TextField,
FormHelperText,
Alert,
CircularProgress,
} from '@mui/material';
import baseUrl from '../../../../../../BaseURL';
import { toast } from 'react-toastify';
import axios from 'axios';
import { Getrequest } from '../../../../../../context/AxiosRequest';

export default function CreditSearch({email,user_tokens,setShowLoanCalculator,showLoanCalculator}) {
    
const [formData, setFormData] = useState({
    search_status: '',
    fileUpload: null,
    comments: '',
});

const [errors, setErrors] = useState({});
const [loading, setLoading] = useState(false);
const [getSearch, setGetSearch] = useState([]);
const [reload, setReload] = useState(false);

const handleCreditSearchChange = (e) => {
    setFormData({ ...formData, search_status: e.target.value });
    setErrors({ ...errors, search_status: '' });
};

const handleFileChange = (e) => {

    const file = e.target.files[0];
    if (file) {
        if (file.size > 5 * 1024 * 1024) {
            setErrors({ ...errors, fileUpload: 'File size must not exceed 1MB' });
            setFormData({ ...formData, fileUpload: null });
        } else {
            setFormData({ ...formData, fileUpload: file });
            setErrors({ ...errors, fileUpload: '' });
        }
    }


};

const handleCommentsChange = (e) => {
    setFormData({ ...formData, comments: e.target.value });
    setErrors({ ...errors, comments: '' });
};

const validateForm = () => {
    const newErrors = {};
    if (!formData.search_status) newErrors.search_status = 'Please select a credit search option';
    if (!formData.fileUpload) newErrors.fileUpload = 'Please upload a file';
    if (!formData.comments.trim()) newErrors.comments = 'Please enter comments';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};

React.useEffect(() => {
    // Fetch existing credit search data if needed
    const fetchCreditSearchData = async () => {

            
              const response = await Getrequest(`/auth/get_credit_search/${user_tokens}`);

                setGetSearch(response);
                if(response.length > 0){

                      if(response[0]?.search_status === "notok")  setShowLoanCalculator("notok");
                      if(response[0]?.search_status === "ok")  setShowLoanCalculator("ok");

                } 
              };             

            fetchCreditSearchData();
    
}, [reload]);

const handleSubmit = async (e) => {

    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {

        const formPayload = new FormData();
        formPayload.append('search_status', formData.search_status);
        formPayload.append('file', formData.fileUpload);
        formPayload.append('comments', formData.comments);
        formPayload.append('user_tokens', user_tokens);
        formPayload.append('email', email);

         axios.post(`${baseUrl}/auth/credit_search`,formPayload,{
          withCredentials: true,
          headers: {
            'Accept' : 'application/json',
            ContentType: "multipart/form-data",
          }}).then(res=>{
      

              if(res.data.status){

                  toast.success(res.data.textStatus);
                  setReload(!reload);
                  
              }else{

                  toast.success(res.data.textStatus);
                  setReload(!reload);
              }

    
          }).catch(err=> {
              if(err){ 
                toast.error(err.message)
                console.log(err)
                return
    
              }   
          })



    } catch (error) {
        console.error('Error:', error);
    } finally {
        setLoading(false);
    }
};

return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 500, mx: 'auto', p: 3 }}>
        <h2 className='pb-2'>Credit Search Form</h2>

            {
             showLoanCalculator === "ok" ? (
                <Alert severity="success" sx={{ mb: 3 }}>
                    Credit Search is Ok. You can proceed to the Loan Calculator.
                </Alert>
            ) : showLoanCalculator === "notok" ? (
                <Alert severity="error" sx={{ mb: 3 }}>
                    Credit Search is Not Ok. 
                </Alert>
            ) : null    
            }

        {

        ( getSearch[0]?.search_status === "not searched" || getSearch.length === 0 )  &&

      <div > 
   
        {/* Credit Search Radio */}
        <Box sx={{ mb: 3 }}>
            <FormHelperText sx={{ mb: 1, fontWeight: 'bold' }}>
                Credit Search {errors.search_status && <span style={{ color: 'red' }}>*</span>}
            </FormHelperText>
            <RadioGroup
                value={formData.search_status}
                onChange={handleCreditSearchChange}
                row
            >
           <FormControlLabel value="ok" control={<Radio />} label="Ok" />
           <FormControlLabel value="notok" control={<Radio />} label="Not Ok" />
            </RadioGroup>
            {errors.search_status && <FormHelperText error>{errors.search_status}</FormHelperText>}
        </Box>

        {/* File Upload */}
        <Box sx={{ mb: 3 }}>
            <TextField
                type="file"
                fullWidth
                inputProps={{ accept: '*' }}
                onChange={handleFileChange}
                error={!!errors.fileUpload}
                helperText={errors.fileUpload || 'Max 1MB'}
                variant="outlined"
            />
        </Box>

        {/* Comments Textarea */}
        <Box sx={{ mb: 3 }}>
            <TextField
                fullWidth
                multiline
                rows={4}
                placeholder="Enter your comments"
                value={formData.comments}
                onChange={handleCommentsChange}
                error={!!errors.comments}
                helperText={errors.comments}
                variant="outlined"
            />
        </Box>

        {/* Submit Button */}
        <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading}
            sx={{ position: 'relative' }}
        >
            {loading ? <CircularProgress size={24} /> : 'Submit'}
        </Button>

        </div>
           
           }
         
    </Box>
);
}